
<template>
  <v-card style="border-radius:12px">
    <v-toolbar flat color="white">
      <v-toolbar-title>Permissões</v-toolbar-title>
      <v-divider class="mx-4" inset vertical ></v-divider>
      <div class="flex-grow-1"></div>
    </v-toolbar>

    <v-card-text>
      <settings-table :headers="headers" @editing="edit_item_id = $event" @deleting="delete_item_id = $event"></settings-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  components: {
    SettingsTable: () => import('@/components/shared/IndexTable'),
  },
  data() {
    return {
      headers:[
        { text: 'Descrição', width: '80%' ,align: 'left', sortable: false, value: 'name'},
        // { text: 'E-mail', width: '30%' ,align: 'left', sortable: false, value: 'email'},
        // { text: 'Cargo', width: '30%' ,align: 'left', sortable: false, value: 'role'},
        // { text: 'Dado 1', value: 'calories' },
        // { text: 'Dado 2', value: 'fat' },
        // { text: 'Dado 3', value: 'carbs' },
        // { text: 'Dado 4', value: 'protein' },
        { text: 'Ação', value: 'action', sortable: false },
      ]
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>